import { setFileTemplate } from '.';
export const uploadFileTemplate = (state, { payload }) => setFileTemplate(state, { payload });
